



import { Modal,  ModalCloseButton,ModalFooter, ModalOverlay, Text, ModalContent, ModalBody, Button, Input,  InputGroup, InputRightElement, Icon } from '@chakra-ui/react'
import {  useEffect, useState } from 'react'
import { TbKey } from 'react-icons/tb'
import { useMutation } from 'react-query'


import { validatePrivateCode } from '../../api/user/play/PlayExpand'
import InvalidInput from '../input/InvalidInput'


const InsertPrivateCodeModal = ({ isOpen, onClose, id , onBook } : {
    isOpen : boolean,
    onClose : () => void,
    id : string,
    token : string,
    onBook : (private_code : string) => void
}) => {

    const [privateCode, setPrivateCode] = useState<string>("")

    
    const [error,setError] = useState<string>("")

    const checkPrivateCode = useMutation(["checkPrivateCode"], validatePrivateCode, {
        onSuccess : () => {
            setError("")
            onBook(privateCode)
            onClose()
            
        },
        onError : () => {
            setError("Invalid code")
        }
    })

    const validateData = () => {
        if(privateCode === ""){
            setError("Field cannot be empty")
            return false
        } else {
            checkPrivateCode.mutate({id : id, private_code : privateCode})
        }
    }

    useEffect(() => {
        setPrivateCode("")
    }, [id])
   


    return <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
        <ModalCloseButton />
        <ModalBody p='0'>

            <Text variant='title' fontSize='2xl' fontWeight='500' mb='20px'>
                This event is private!
            </Text>

            <Text>Enter invite code for this event</Text>
            <InputGroup>
                <Input
                    value={privateCode}
                    onChange={(e : any) => {
                        setPrivateCode(e.target.value)
                    }}
                />
                <InputRightElement pointerEvents='none' color='gray.400' fontSize='1.2em'>
                    <Icon as={TbKey}/>
                </InputRightElement>
            </InputGroup>
            <InvalidInput isError={error != ""} override={error}/>
                        
        </ModalBody>
        <ModalFooter>
            <Button variant="heavy" size='sm' 
                isLoading={checkPrivateCode.isLoading}
                onClick={() => {
                    
                    validateData()
                }}
            >Book</Button>
        </ModalFooter>
    </ModalContent>
</Modal>
}

export default InsertPrivateCodeModal;